import { gql } from "@stadium/services/apollo-client";

export const FETCH_DRAFT_CATALOG_SELECTED_PRODUCTS_PRESENCE = gql`
  query draftCatalogSelectedProductsPresence($number: String!, $productIds: [Int!]!) {
    draftCatalogSelectedProductsPresence(number: $number, productIds: $productIds)
  }
`;
